import { sha256 } from "@noble/hashes/sha256"

const NEAR_RP_ID = "near.com"
const NEAR_RP_HOSTS = new Set(["near.com", "preview.near.com"])
const REQUIRED_USER_FLAGS = 0x05

export function expectedRpIdForHostname(hostname: string): string {
  return NEAR_RP_HOSTS.has(hostname) ? NEAR_RP_ID : hostname
}

export function verifyWebAuthnCeremony({
  authenticatorData: authenticatorDataValue,
  clientDataJSON: clientDataJSONValue,
  expectedOrigin,
  expectedRpId,
}: {
  authenticatorData: ArrayBuffer | Uint8Array
  clientDataJSON: ArrayBuffer | Uint8Array
  expectedOrigin: string
  expectedRpId: string
}): boolean {
  const authenticatorData = bytes(authenticatorDataValue)
  if (
    authenticatorData.length < 37 ||
    (authenticatorData[32] & REQUIRED_USER_FLAGS) !== REQUIRED_USER_FLAGS
  ) {
    return false
  }

  const rpIdHash = sha256(new TextEncoder().encode(expectedRpId))
  if (!equal(authenticatorData.subarray(0, 32), rpIdHash)) return false

  try {
    const clientData = JSON.parse(
      new TextDecoder().decode(bytes(clientDataJSONValue))
    ) as {
      type?: unknown
      origin?: unknown
      crossOrigin?: unknown
    }
    return (
      clientData.type === "webauthn.get" &&
      clientData.origin === expectedOrigin &&
      clientData.crossOrigin !== true
    )
  } catch {
    return false
  }
}

function bytes(value: ArrayBuffer | Uint8Array): Uint8Array {
  return value instanceof Uint8Array ? value : new Uint8Array(value)
}

function equal(a: Uint8Array, b: Uint8Array): boolean {
  if (a.length !== b.length) return false
  let difference = 0
  for (let index = 0; index < a.length; index++) {
    difference |= a[index] ^ b[index]
  }
  return difference === 0
}
